function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { guid } from '@bydesign-ui/utils';
export var FileClass = function () {
  function FileClass(props) {
    _classCallCheck(this, FileClass);

    this.previewUrl = '';
    this.fileStatus = "INIT";
    this.errmsg = '';
    var id = props.id,
        name = props.name,
        data = props.data,
        url = props.url,
        fileType = props.fileType,
        file = props.file,
        href = props.href;
    this.id = id ? id : guid();
    this.name = name || '';
    this.data = data;
    this.url = url || '';
    this.fileType = fileType || "file";
    this.progress = 100;
    this.errmsg = props.errmsg || '';
    this.href = href || '';

    if (url) {
      this.fileStatus = "DONE";
    }

    if (props.fileStatus) {
      this.fileStatus = props.fileStatus;
    }

    if (file) {
      this.originFile = file;
      this.file = file;
      this.name = this.getName(file.name);
      this.progress = 0;

      if (this.isImageUrl(file)) {
        if (!fileType) {
          this.fileType = "image";
        }

        if (this.fileType === "image") {
          this.previewUrl = window.URL.createObjectURL(file);
        }
      }
    }
  }

  _createClass(FileClass, [{
    key: "updateFile",
    value: function updateFile(options) {
      if (options.file && this.file !== options.file) {
        this.previewUrl = window.URL.createObjectURL(options.file);
      }

      for (var name in options) {
        if (Object.prototype.hasOwnProperty.call(options, name)) {
          this[name] = options[name];
        }
      }

      return this;
    }
  }, {
    key: "getFileName",
    value: function getFileName() {
      return this.name ? this.name : this.url;
    }
  }, {
    key: "setStatus",
    value: function setStatus(status) {
      this.fileStatus = status;
    }
  }, {
    key: "getProgress",
    value: function getProgress() {
      return this.progress;
    }
  }, {
    key: "setProgress",
    value: function setProgress(progress) {
      this.progress = progress;
    }
  }, {
    key: "getName",
    value: function getName(path) {
      return path.split('/').pop() || '';
    }
  }, {
    key: "getExtName",
    value: function getExtName(path) {
      if (!path) {
        return '';
      }

      var filename = path.split('/').pop() || '';
      var filenameWithoutSuffix = filename.split(/[?#]/)[0];
      return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
    }
  }, {
    key: "isImageUrl",
    value: function isImageUrl(file) {
      if (file.type.indexOf('image/') === 0) {
        return true;
      }

      var url = file.name;
      var extension = this.getExtName(url);

      if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|bmp|dpg)$/i.test(extension)) {
        return true;
      } else if (/^data:/.test(url)) {
        return false;
      }

      return false;
    }
  }, {
    key: "getBaseFile",
    value: function getBaseFile() {
      return {
        id: this.id,
        name: this.name,
        url: this.url,
        fileType: this.fileType,
        fileStatus: this.fileStatus,
        data: this.data,
        file: this.file
      };
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.previewUrl) {
        window.URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = '';
      }
    }
  }]);

  return FileClass;
}();